import {BenjiKIV} from "../../../BenjiKIV";
import {BenjiKIVGameAssets} from "../../../BenjiKIVGameAssets";
import {gsap} from "gsap";
import {BenjiKIVSound} from "../../../sound/BenjiKIVSound";
import {SpineUtils} from "../../../utils/SpineUtils";

/**
 * Created by Jerker Nord on 2022-12-08.
 */

export class BenjiKIVRingGirl extends PIXI.Container {

    private static ANIMATION_NAME:string = "Ring_Girl_A";
    private static RESULT_CONTAINER_POSITION:PIXI.Point = new PIXI.Point(-71, -209);
    private static MULTIPLIER_POSITION:PIXI.Point = new PIXI.Point(100, 14);

    private _ringGirlAnimation:PIXI.spine.Spine;
    private _ringGirlResultContainer:PIXI.Container;
    private _xSplitResult:PIXI.Sprite;
    private _isUsed:boolean;
    private _multiplierValue:number;
    private _multiplierText:PIXI.BitmapText;

    constructor() {
        super();
        this.init();
    }

    private init():void {
        this._isUsed = false;
        this._ringGirlAnimation = new PIXI.spine.Spine(BenjiKIV.assetLoader.getSpineAsset(BenjiKIVGameAssets.RING_GIRL_SPINE));
        this.addChild(this._ringGirlAnimation);
        this._ringGirlResultContainer = new PIXI.Container();
        this._ringGirlResultContainer.position = BenjiKIVRingGirl.RESULT_CONTAINER_POSITION;
        this.addChild(this._ringGirlResultContainer);
        this._xSplitResult = new PIXI.Sprite(BenjiKIV.assetLoader.getTextures("Enhancers/xsplit_x")[0]);
        this._xSplitResult.anchor.set(0.5, 0.5);
        this._xSplitResult.position.x = 70;
        this._xSplitResult.position.y = 40;
        this._xSplitResult.alpha = 0;
        this._ringGirlResultContainer.addChild(this._xSplitResult);

        this._multiplierText = new PIXI.BitmapText("x0", {
            fontName : BenjiKIVGameAssets.BITMAP_FONT_SYMBOL_MULTIPLIER,
            fontSize : 45
        });
        this._multiplierText.anchor = new PIXI.Point(1, 0);
        this._multiplierText.position = BenjiKIVRingGirl.MULTIPLIER_POSITION;
        this._multiplierText.alpha = 0;
        this._ringGirlResultContainer.addChild(this._multiplierText);
    }

    public getRingGirlShowSplitAnimation():gsap.core.Timeline {
        const splitTL:gsap.core.Timeline = gsap.timeline();
        splitTL.add(() => {
            this._ringGirlAnimation.alpha = 1;
            SpineUtils.resetSpineAnimation(this._ringGirlAnimation);
        })
        splitTL.add([
            () => {
                BenjiKIV.soundPlayer.playSound(BenjiKIVSound.RING_GIRL_SPLIT);
                this._ringGirlAnimation.state.setAnimation(0, BenjiKIVRingGirl.ANIMATION_NAME, false);
            },
            gsap.timeline({delay : 0.2}).add(gsap.to(this._xSplitResult, {duration : 0.8, alpha : 1}))
        ]);
        splitTL.add([
            gsap.to(this._xSplitResult, {duration : 0.2, alpha : 0}),
            gsap.to(this._ringGirlAnimation, {duration : 0.2, alpha : 0})
        ]);
        return splitTL;
    }

    public getMultiAnimation(multiValue:number):gsap.core.Timeline {
        const multiTL:gsap.core.Timeline = gsap.timeline();
        multiTL.add(() => {
            this._ringGirlAnimation.alpha = 1;
            SpineUtils.resetSpineAnimation(this._ringGirlAnimation);
            this._multiplierText.text = multiValue.toString() + "x";
        })
        multiTL.add([
            () => {
                BenjiKIV.soundPlayer.playSound(BenjiKIVSound.RING_GIRL_MULTI);
                this._ringGirlAnimation.state.setAnimation(0, BenjiKIVRingGirl.ANIMATION_NAME, false);
            },
            gsap.timeline({delay : 0.2}).add(gsap.to(this._multiplierText, {duration : 0.8, alpha : 1}))
        ]);
        multiTL.add([
            gsap.to(this._multiplierText, {duration : 0.2, alpha : 0}),
            gsap.to(this._ringGirlAnimation, {duration : 0.2, alpha : 0})
        ]);
        return multiTL;
    }

    get isUsed():boolean {
        return this._isUsed;
    }

    set isUsed(value:boolean) {
        this._isUsed = value;
    }
}